import $ from 'jquery';

const swiperInertFix = () => {
	const el = {
		slide: '.swiper-slide',
	};

	if ($(el.slide).length === 0) return;

	const stripInertFromSlides = ($root) => {
		$root
			.find(`${el.slide}[inert], ${el.slide}[aria-hidden="true"]`)
			.removeAttr('inert')
			.removeAttr('aria-hidden');
	};

	const observeSlides = () => {
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				const target = mutation.target;

				if (
					target.classList &&
					target.classList.contains('swiper-slide') &&
					(mutation.attributeName === 'inert' ||
						mutation.attributeName === 'aria-hidden')
				) {
					target.removeAttribute('inert');
					target.removeAttribute('aria-hidden');
				}
			});
		});

		observer.observe(document.body, {
			attributes: true,
			subtree: true,
			attributeFilter: ['inert', 'aria-hidden'],
		});
	};

	const init = () => {
		stripInertFromSlides($(document));
		observeSlides();
	};

	init();
};

try {
	swiperInertFix();
} catch (error) {
	console.error('swiperInertFix', error);
}
